export const enum EShadows {
  basic = '0px 12px 24px 0px rgba(39, 39, 39, 0.20)',
}
